<template>
  <img
    class="lazy-bg"
    :class="`lazy-bg--${fit}`"
    :src="src"
    alt=""
    :loading="eager ? 'eager' : 'lazy'"
    :fetchpriority="eager ? 'high' : undefined"
    decoding="async"
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** Vite 解析后的图片 URL */
    src: string;
    /** 首屏 LCP 图用 eager */
    eager?: boolean;
    fit?: 'cover' | 'contain' | 'fill';
  }>(),
  {
    eager: false,
    fit: 'cover'
  }
);
</script>

<style scoped>
.lazy-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
}

.lazy-bg--cover {
  object-fit: cover;
  object-position: center;
}

.lazy-bg--contain {
  object-fit: contain;
  object-position: center;
}

.lazy-bg--fill {
  object-fit: fill;
}
</style>
